<template>
  <v-dialog
    v-model="isShown"
    max-width="500px"
    retain-focus
    persistent
    @keydown.esc="doCancel"
  >
    <!-- pass through activator slot -->
    <template v-slot:activator="slotData">
      <slot v-if="$scopedSlots.activator" name="activator" v-bind="slotData" />
    </template>

    <v-card>
      <v-card-title :class="titleCssClass">
        {{ title }}
      </v-card-title>

      <v-card-text>
        <v-container>
          <!-- // eslint-disable-next-line -->
          <v-row v-html="message">
          </v-row>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="doCancel">
          {{ cancelButtonText }}
        </v-btn>
        <v-btn text :color="okButtonColor" @click="doConfirm">
          {{ okButtonText }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
const types = {
  default: {
    titleClass: 'primary white--text',
    okButtonColor: 'primary',
    okButtonText: 'OK',
    cancelButtonText: 'Cancel'
  },
  delete: {
    titleClass: 'red darken-1 white--text',
    okButtonColor: 'error',
    okButtonText: 'Delete',
    cancelButtonText: 'Cancel'
  }
}

export default {
  props: {
    type: {
      type: String,
      default: 'default'
    },
    title: {
      type: String,
      required: true
    },
    message: {
      type: String,
      required: true
    },
    value: {
      type: Boolean,
      required: false
    },
    okButtonText: {
      type: String,
      default: 'OK'
    }
  },
  data () {
    return {
      isShown: false
    }
  },
  computed: {
    typeData () {
      return types[this.type]
    },
    titleCssClass () {
      return `headline ${this.typeData.titleClass}`
    },
    okButtonTextC () {
      return this.okButtonText || this.typeData.okButtonText
    },
    okButtonColor () {
      return this.typeData.okButtonColor
    },
    cancelButtonText () {
      return this.typeData.cancelButtonText
    }
  },
  mounted () {
    this.isShown = this.value
  },
  methods: {
    doConfirm () {
      this.isShown = false
      this.$emit('confirm')
    },
    doCancel () {
      this.isShown = false
      this.$emit('cancel')
    }
  }
}
</script>

<style scoped></style>
